<template>
    <CodiceFeanorView tool-module="steghideSuite" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
